import type { ReactNode } from "react";

interface StatCardProps {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  tone?: "default" | "good" | "warn" | "bad";
}

const TONE: Record<string, { bg: string; fg: string }> = {
  default: { bg: "white", fg: "hsl(215,16%,30%)" },
  good: { bg: "hsl(142,55%,96%)", fg: "hsl(142,72%,28%)" },
  warn: { bg: "hsl(38,92%,96%)", fg: "hsl(38,92%,30%)" },
  bad: { bg: "hsl(0,84%,97%)", fg: "hsl(0,72%,42%)" },
};

export function StatCard({ label, value, hint, tone = "default" }: StatCardProps) {
  const t = TONE[tone];
  return (
    <div
      className="rounded-xl border p-4"
      style={{ borderColor: "hsl(210,30%,85%)", background: t.bg }}
    >
      <div className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
        {label}
      </div>
      <div className="mt-1 text-[22px] font-semibold" style={{ color: t.fg }}>
        {value}
      </div>
      {hint && (
        <div className="mt-1 text-[12px] text-muted-foreground">{hint}</div>
      )}
    </div>
  );
}
